import { Routes } from '@angular/router';
import { RoleGuard } from '../../common/guards/role.guard';
import { Roles } from '../../common/models/roles';
import { GrantsComponent } from './grants/grants.component';
import { AuthGuard } from '../../common/guards/auth.guard';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationComponent } from './/notification/notification.component';
import { ApplicationsComponent } from './applications/applications.component';
import { AllocationsComponent } from './allocations/allocations.component';
import { ProjectsComponent } from './projects/projects.component';
import { ReportsComponent } from './projects/reports/list/reports.component';
import { DescriptionComponent } from './projects/reports/description/description.component';
import { ExpenditureComponent } from './projects/reports/expenditure/expenditure.component';
import { ApplicationViewComponent } from './application/view/application-view.component';
import { ApplicationComponent } from './application/application.component';
import { ProjectBudgetsComponent } from './projects/budgets/list/budgets.component';
import { ProjectBudgetComponent } from './projects/budgets/edit/budget.component';
import { ProjectBudgetViewComponent } from './projects/budgets/view/budget-view.component';
import { FilterScopeResolver } from '../../common/components/filter/resolver/filter-scope.resolver';
import { AllocationComponent } from './allocation/allocation.component';
import { AllocationViewComponent } from './allocation/view/allocation-view.component';
import { RefundsComponent } from './projects/refunds/list/refunds.component';
import { RefundViewComponent } from './projects/refunds/view/refund-view.component';
import { DescriptionViewComponent } from './projects/reports/description/view/description-view.component';
import { ExpenditureViewComponent } from './projects/reports/expenditure/view/expenditure-view.component';
import { SaldoComponent } from './projects/saldo/saldo.component';

export const associationRoutes: Routes = [
    {
      path: 'association',
      canActivate: [AuthGuard, RoleGuard],
      data: { roles: [Roles.AssociationResponsiblePerson] },
      resolve: { setScope: FilterScopeResolver },
      runGuardsAndResolvers: 'always',
      children: [
        { path: 'grants', component: GrantsComponent },
        { path: 'notifications', component: NotificationsComponent},
        { path: 'notifications/:id/view', component: NotificationComponent},
        { path: 'applications', component: ApplicationsComponent },
        { path: 'applications/:grantId/create', component: ApplicationComponent},
        { path: 'applications/:applicationId/edit', component: ApplicationComponent },
        { path: 'applications/:applicationId/view', component: ApplicationViewComponent},
        { path: 'allocations', component: AllocationsComponent },
        { path: 'allocations/create', component: AllocationComponent},
        { path: 'allocations/:allocationId/edit', component: AllocationComponent },
        { path: 'allocations/:allocationId/view', component: AllocationViewComponent},
        { path: 'projects', component: ProjectsComponent },
        { path: 'projects/:projectId/budgets', component: ProjectBudgetsComponent },
        { path: 'projects/:projectId/budgets/:projectBudgetId/edit', component: ProjectBudgetComponent },
        { path: 'projects/:projectId/budgets/:projectBudgetId/view', component: ProjectBudgetViewComponent },
        { path: 'projects/:projectId/saldo', component: SaldoComponent },
        { path: 'projects/:projectId/refunds', component: RefundsComponent },
        { path: 'projects/:projectId/refunds/:refundId/view', component: RefundViewComponent },
        { path: 'projects/:projectId/reports', component: ReportsComponent },
        { path: 'projects/:projectId/reports/description/create',  component: DescriptionComponent },
        { path: 'projects/:projectId/reports/description/:reportId/edit', component: DescriptionComponent  },
        { path: 'projects/:projectId/reports/description/:reportId/view', component: DescriptionViewComponent  },
        { path: 'projects/:projectId/reports/expenditure/create', component: ExpenditureComponent },
        { path: 'projects/:projectId/reports/expenditure/:reportId/edit', component: ExpenditureComponent },
        { path: 'projects/:projectId/reports/expenditure/:reportId/view', component: ExpenditureViewComponent }
      ]
    }

]